import React from 'react';
import styled from 'styled-components';
import loginLogo from '../../assets/images/loginLogo.png';

const LogoImage = styled.img`
  padding: 20px;
  width: 100%;
  max-width: 360px;
  position: absolute;
  bottom: 60px;
  @media (max-width: 480px) {
    bottom: 30px;
  }
`;

function BackgroundLogo() {
  return (
    <>
      <LogoImage src={loginLogo} alt="Login Logo" />
    </>
  );
}

export default BackgroundLogo;
